const baseText = {
  fontSize: { xs: '12px', md: '14px' },
  lineHeight: { xs: '14px', md: '16px' }
}

const baseIcon = {
  width: { xs: '14px', md: '16px' },
  height: { xs: '14px', md: '16px' }
}

export const languageDropdownSx = {
  text: (isPick = false) => ({
    ...baseText,
    color: isPick ? 'primary.main' : 'text.primary',
    wordBreak: 'keep-all'
  }),
  textLang: (isDisabled = false) => ({
    ...baseText,
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    color: isDisabled ? 'info.main' : 'text.primary',
    wordBreak: 'keep-all',
    lineHeight: '24px'
  }),
  buttonLang: (isPointer = true) => ({
    display: 'flex',
    m: 0,
    p: 0,
    minWidth: '0px',
    minHeight: '0px',
    borderRadius: '0px',
    cursor: isPointer ? 'pointer' : 'default'
  }),
  listItemButton: {
    minHeight: 0,
    minWidth: 0,
    width: '100%',
    borderRadius: 0
  },
  imageIcon: (isRtl = false, isDark = false, isOpen = false) => ({
    ...baseIcon,
    filter: isDark ? 'invert(1)' : null,
    transform: isRtl && isOpen ? 'scaleX(-1) rotate(270deg)' : isRtl ? 'scaleX(-1)' : isOpen ? 'rotate(270deg)' : ''
  }),
  muiIcon: () => ({
    ...baseIcon,
    color: 'primary.main'
  }),
  popper: (anchorWidth?: number) => ({
    backgroundColor: 'background.paper',
    width: anchorWidth || 'auto',
    outline: 'none',
    mb: 1,
    p: 1,
    borderRadius: '22px'
  })
}
